/* ScrubMe – ATC gradient by variant (ONLY after user selects OR URL has ?variant=)
   CLS-safe: paint-only (background + color). No font/transform/size changes.
*/
(function () {
  const SELECTORS = {
    atc: ".product__info-wrapper .product-form__submit[name='add']",
    variantBlob: "[data-selected-variant]",
    colorFieldset:
      'fieldset[data-option-name="Select Colour"], fieldset[data-option-name="Select Color"], fieldset[data-option-name="Colour"], fieldset[data-option-name="Color"]',
    colorSelect:
      'select[name="options[Select Colour]"], select[name="options[Select Color]"], select[name="options[Colour]"], select[name="options[Color]"], select[name^="options["]',
    swatchLabel: ".product-form__input--swatch .variant-swatch__label",
  };

  const GRADIENTS = {
    "passionate purple": ["#71034F", "#C604DA"],
    "breathtaking blue": ["#023B81", "#071EE1"],
  };

  const norm = (s) => (s || "").trim().toLowerCase();
  const getATC = () => document.querySelector(SELECTORS.atc);

  let userInteracted = false;
  let lastKey = null;

  function getVariantParam() {
    try {
      return new URL(window.location.href).searchParams.get("variant");
    } catch (e) {
      return null;
    }
  }

  function getTitleFromUI() {
    const fieldset = document.querySelector(SELECTORS.colorFieldset);
    if (fieldset) {
      const checked = fieldset.querySelector('input[type="radio"]:checked');
      if (checked && checked.value) return checked.value;
    }

    const select = document.querySelector(SELECTORS.colorSelect);
    if (select && select.value) return select.value;

    return null;
  }

  function getTitleFromBlob() {
    const blob = document.querySelector(SELECTORS.variantBlob);
    if (!blob) return null;
    try {
      const obj = JSON.parse(blob.textContent || "{}");
      return obj && obj.title ? obj.title : null;
    } catch (e) {
      return null;
    }
  }

  function applyGradient(btn, pair) {
    // CLS-safe: only paint properties
    btn.style.background = `linear-gradient(90deg, ${pair[0]}, ${pair[1]})`;
    btn.style.color = "#fff";
  }

  function clearGradient(btn) {
    btn.style.background = "";
    btn.style.color = "";
    lastKey = null;
  }

  function paintNow(forceResetIfUnmapped) {
    const btn = getATC();
    if (!btn) return;

    const title = getTitleFromUI() || getTitleFromBlob();
    if (!title) return;

    const key = norm(title);
    const pair = GRADIENTS[key];

    if (!pair) {
      if (forceResetIfUnmapped) clearGradient(btn);
      return;
    }

    if (lastKey === key) return;
    applyGradient(btn, pair);
    lastKey = key;
  }

  // Paint only if user clicked/changed, OR page has ?variant= (deep link)
  function allowedToPaint() {
    return userInteracted || !!getVariantParam();
  }

  // You requested: only apply after the variant URL is in place.
  function waitForVariantUrlThenPaint() {
    let frames = 0;
    const maxFrames = 60; // ~1s worst case
    (function tick() {
      if (getVariantParam()) {
        paintNow(false);
        return;
      }
      if (frames++ >= maxFrames) {
        // Fallback in case URL param doesn't update (keeps UX working)
        paintNow(false);
        return;
      }
      requestAnimationFrame(tick);
    })();
  }

  // Initial load: only paint if deep-linked with ?variant=
  document.addEventListener("DOMContentLoaded", () => {
    if (getVariantParam()) {
      requestAnimationFrame(() => paintNow(false));
    }
  });

  // User clicks swatch label
  document.addEventListener(
    "click",
    (e) => {
      if (e.target && e.target.closest && e.target.closest(SELECTORS.swatchLabel)) {
        userInteracted = true;
        waitForVariantUrlThenPaint();
      }
    },
    true
  );

  // User changes radio/select
  document.addEventListener(
    "change",
    (e) => {
      if (!e.target) return;

      const isRadio = e.target.matches('input[type="radio"]');
      const isSelect = e.target.matches('select[name^="options["]');

      if (isRadio || isSelect) {
        userInteracted = true;
        waitForVariantUrlThenPaint();
      }
    },
    true
  );

  // Variant event: ignore init fires unless allowed (prevents variant-1 flash)
  document.addEventListener("variant:change", () => {
    if (!allowedToPaint()) return;
    requestAnimationFrame(() => paintNow(false));
  });

  // Theme editor reloads
  document.addEventListener("shopify:section:load", () => {
    if (!allowedToPaint()) return;
    requestAnimationFrame(() => paintNow(false));
  });
  document.addEventListener("shopify:section:reorder", () => {
    if (!allowedToPaint()) return;
    requestAnimationFrame(() => paintNow(false));
  });
})();
